import React, {useEffect} from 'react'
import {Helmet} from 'react-helmet'
import {Global, css} from '@emotion/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const Fonts = () => {
    useEffect(() => {
        if (typeof document === 'undefined') return

        const ensureStylesheet = (href) => {
            if (document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) return
            const link = document.createElement('link')
            link.rel = 'stylesheet'
            link.href = href
            link.setAttribute('data-persistent-font', 'true')
            document.head.appendChild(link)
        }

        // Preload external font stylesheets
        const gfonts =
            'https://fonts.googleapis.com/css2?family=Cormorant:wght@400&family=Inter:wght@300;400;500&display=swap'
        const typekit = 'https://use.typekit.net/igi7ndd.css'
        const typekit2 = 'https://use.typekit.net/hwa4jxl.css'

        // Load stylesheets (will use preloaded responses)
        ensureStylesheet(gfonts)
        ensureStylesheet(typekit)
        ensureStylesheet(typekit2)
    }, [])

    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://res.cloudinary.com" />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
                <link rel="preconnect" href="https://use.typekit.net" />
                <link rel="preconnect" href="https://www.googletagmanager.com" />

                <link
                    rel="preload"
                    href="https://fonts.googleapis.com/css2?family=Cormorant:wght@400&family=Inter:wght@300;400;500&display=swap"
                    as="style"
                />

                <link rel="preload" href="https://use.typekit.net/igi7ndd.css" as="style" />
                <link rel="stylesheet" href="https://use.typekit.net/igi7ndd.css" />
                <link rel="preload" href="https://use.typekit.net/hwa4jxl.css" as="style" />
                <link rel="stylesheet" href="https://use.typekit.net/hwa4jxl.css" />
            </Helmet>
            <Global
                styles={css`
                    * {
                        -webkit-font-smoothing: auto;
                        -moz-osx-font-smoothing: auto;
                    }

                    @font-face {
                        font-family: 'Inter';
                        font-display: swap;
                    }
                    @font-face {
                        font-family: 'Cormorant';
                        font-display: swap;
                    }
                    @font-face {
                        font-family: 'brandon-grotesque';
                        font-display: swap;
                    }
                `}
            />
            <Global
                styles={`
                    @font-face {
                        font-family: 'KendraScott';
                        font-style: normal;
                        font-weight: 400;
                        font-display: swap;
                        src: url(${getAssetUrl(
                            'static/fonts/kendra-characters-24-01-22.woff2'
                        )}) format('woff2');
                    }
                `}
            />
        </>
    )
}

export default Fonts
